const myPage = {
    myPage: {
        pageTitle: 'My Page',
        pageDescription: '계정 정보',
        button: {
            deleteAccount: '계정 탈퇴'
        },
        account: {
            title: '계정 정보',
            name: '이름',
            company: '소속',
            country: '국가',
            purpose: '사용 목적',
            password: '비밀번호',
            changePassword: '비밀번호 변경',
            save: '변경사항 저장',
            updated: '개인 정보가 성공적으로 수정되었습니다.',
            passwordChanged: '비밀번호가 변경되었습니다.'
        },
        payment: {
            title: '카드 결제 내역',
            error: '결제 데이터를 불러오는 중 오류가 발생했습니다.',
            empty: '결제 내역이 없습니다',
            button: '스케줄 예약으로 이동'
        },
        bank: {
            title: '이체 내역',
            empty: '이체 내역이 없습니다',
            button: '스케줄 예약으로 이동'
        },
        changePassword: {
            title: '비밀번호 변경',
            current: '현재 비밀번호',
            new: '새 비밀번호',
            confirm: '비밀번호 확인',
            cancel: '취소',
            submit: '변경하기',
            error: {
                wrongCurrent: '현재 비밀번호가 올바르지 않습니다. 다시 시도해주세요.',
                samePassword: '새 비밀번호가 현재 비밀번호와 동일합니다. 다른 비밀번호를 입력해주세요.',
                mismatch: '비밀번호가 일치하지 않습니다.',
                weak: '비밀번호는 최소 8자 이상이며, 영문/숫자/특수문자를 포함해야 합니다.'
            }
        }
    }

};

export default myPage;